import { useMemo, useState } from 'react'

import { Button } from '@wartek-id/button-v1'
import { Icon } from '@wartek-id/icon-v2'
import { Text } from '@wartek-id/text-v1'

import { PltKepalaSekolahConfirmationDialog } from 'app/KinerjaShared/components/PltKepalaSekolahConfirmationDialog'

import type { PelaksanaanSchool } from 'types/kinerja-pelaksanaan'

type PltKepalaSekolahConfirmationCardProps = {
  schools: PelaksanaanSchool[]
  kepalaSekolahLabel?: string
  pegawaiLabel?: string
}
export function PltKepalaSekolahConfirmationCard({
  schools,
  kepalaSekolahLabel = 'Kepala Sekolah',
  pegawaiLabel = 'Guru',
}: PltKepalaSekolahConfirmationCardProps) {
  // -----------------------------------------
  // Handle dialog
  // -----------------------------------------
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false)

  const handleShowConfirmationDialog = () => setShowConfirmationDialog(true)

  // -----------------------------------------
  // Resolve render flag
  // -----------------------------------------
  // Check if there is unconfirmed sekolah negeri
  const haveUnconfirmedPublicSchools = useMemo(
    () =>
      schools?.some(
        (school) =>
          school.statusSatuanPendidikan == 'NEGERI' &&
          school.confirmationStatus == 'UNCONFIRMED'
      ),
    [schools]
  )

  if (!haveUnconfirmedPublicSchools) return null

  return (
    <>
      <section
        className={
          'flex p-5 gap-6 border rounded-lg shadow-card bg-white space-between items-start !border-interactive-critical-default'
        }
      >
        <div className="flex gap-6">
          <Icon color="critical" fontSize="lg">
            warning
          </Icon>
          <div className="space-y-1">
            <Text variant="heading-lg" as="h2">
              Penting! Pengelolaan Kinerja tertunda
            </Text>
            <Text color="subdued">
              Mohon segera konfirmasi data Anda sebagai {kepalaSekolahLabel}{' '}
              berstatus Plt. (Pelaksana Tugas) untuk melanjutkan Pengelolaan
              Kinerja satuan pendidikan Anda.
            </Text>
          </div>
        </div>
        <Button
          size="lg"
          className="ml-auto flex-shrink-0"
          onClick={handleShowConfirmationDialog}
        >
          Konfirmasi data
        </Button>
      </section>

      <PltKepalaSekolahConfirmationDialog
        schools={schools}
        kepalaSekolahLabel={kepalaSekolahLabel}
        pegawaiLabel={pegawaiLabel}
        isOpen={showConfirmationDialog}
        onClose={() => setShowConfirmationDialog(false)}
      />
    </>
  )
}
